import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import { ReactNode } from 'react'

import ArrowDownIcon from '../../../../../../../packages/ui/icons/arrow-down'

type Props = {
  points: ReactNode[]
  title: string
  titleExplanation?: string
  note?: ReactNode
}

const ArrowPoints = ({ points, title, titleExplanation, note }: Props) => {
  return (
    <div>
      <Typography variant="caption" color={tailwindColors.black.DEFAULT}>
        {title}&nbsp;
        {titleExplanation && <span className="font-normal">({titleExplanation}) :</span>}
      </Typography>
      <div className="h-2" />
      <div className="flex flex-col gap-1">
        {points.map((point, index) => (
          <div key={index} className="flex items-center gap-2">
            <ArrowDownIcon
              className="w-4 h-4 -rotate-90 "
              color={tailwindColors.secondary.DEFAULT}
            />
            {point}
          </div>
        ))}
        {note && <div className="pl-6">{note}</div>}
      </div>
    </div>
  )
}

export default ArrowPoints
